import React, { memo, useState, useEffect } from "react";
import { Modal } from "antd";

import { normalizeBoolean, useClient } from "../../../hooks/ClientProvider";
import { useClientHorizon } from "../../../hooks/useClientHorizon";
import { formatDate, getFormatDateReverse } from "../../../utils/formatDate";
import * as S from "../style";

function InformationCardModal({ isModalVisible, closeModal, card }) {
  const [dataEmissao, setDataEmissao] = useState("");

  const { client, cardFinancial } = useClient();
  const { data: clientHorizon } = useClientHorizon(client?.client?.id, {
    enabled: Boolean(isModalVisible),
  });
  const clientExtractData = clientHorizon?.extratoClienteResponse || {};
  const devedorTotal = clientExtractData?.devedorTotal || 0;
  const utilizaLimiteExtra = normalizeBoolean(client?.client?.utilizaLimiteExtra);
  const saldoDisponivelExtra = client?.client?.saldoDisponivelExtra;

  useEffect(() => {
    if (card?.dataEmissao) {
      const raw = String(card.dataEmissao);
      const match = raw.match(/^(\d{2})-(\d{2})-(\d{4})$/);
      if (match) {
        const [, day, mon, year] = match;
        setDataEmissao(formatDate(`${year}-${mon}-${day}`));
      } else {
        setDataEmissao(formatDate(raw));
      }
    }
  }, [card?.dataEmissao]);

  if (!client) {
    return null;
  }

  const saldoDisponivelExibicao = utilizaLimiteExtra
    ? Number(saldoDisponivelExtra || 0)
    : Number(cardFinancial?.saldoDisponivel || 0);

  return (
    <Modal title="Informações" visible={isModalVisible} onCancel={closeModal} footer={null}>
      <S.InformationCardContainer>
        <S.CreditCardRow>
          <span>Número:</span>
          <span>{card?.numeroMascarado}</span>
        </S.CreditCardRow>

        {dataEmissao && (
          <S.CreditCardRow>
            <span>Data de Emissão:</span>
            <span>{dataEmissao}</span>
          </S.CreditCardRow>
        )}

        <S.CreditCardRow>
          <span>Nome:</span>
          <span>{card?.nome}</span>
        </S.CreditCardRow>

        {card?.bandeira && (
          <S.CreditCardRow>
            <span>Bandeira:</span>
            <span>{card.bandeira}</span>
          </S.CreditCardRow>
        )}

        {card?.funcaoCartao && (
          <S.CreditCardRow>
            <span>Tipo de cartão:</span>
            <span>{card.funcaoCartao}</span>
          </S.CreditCardRow>
        )}

        <S.CreditCardRow>
          <span>Dia do vencimento da fatura:</span>
          <b>{client?.information?.diaVencimento}</b>
        </S.CreditCardRow>

        <S.CreditCardRow>
          <span>Melhor dia para compra:</span>
          <b>{client?.information?.melhorDiaCompra}</b>
        </S.CreditCardRow>

        {clientExtractData.limite >= 0 && clientExtractData.valorLimiteExtra >= 0 && (
          <S.CreditCardRow>
            <span>Limite total:</span>
            <b>
              R${" "}
              {Number(
                clientExtractData.limite + clientExtractData.valorLimiteExtra
              ).toFixed(2)}
            </b>
          </S.CreditCardRow>
        )}

        {clientExtractData.limite >= 0 && (
          <S.CreditCardRow>
            <span>Limite praticado:</span>
            <b>R$ {Number(clientExtractData.limite).toFixed(2)}</b>
          </S.CreditCardRow>
        )}

        {clientExtractData.valorLimiteExtra >= 0 && clientExtractData.limite > 0 && (
          <S.CreditCardRow>
            <span>Limite extra (%):</span>
            <b>
              {Number(
                (clientExtractData.valorLimiteExtra / clientExtractData.limite) * 100
              ).toFixed(2)}
              %
            </b>
          </S.CreditCardRow>
        )}

        <S.CreditCardRow>
          <span>Limite disponível:</span>
          <b>R$ {saldoDisponivelExibicao.toFixed(2)}</b>
        </S.CreditCardRow>

        <S.CreditCardRow>
          <span>Devedor Total:</span>
          <b>R$ {Number(devedorTotal || 0).toFixed(2)}</b>
        </S.CreditCardRow>

        <S.CreditCardRow>
          <span>Limite saque:</span>
          <b>R$ {Number(client?.information?.limiteSaque || 0).toFixed(2)}</b>
        </S.CreditCardRow>

        <S.CreditCardRow>
          <span>Saldo disponível saque:</span>
          <b>R$ {Number(client?.information?.saldoDisponivelSaque || 0).toFixed(2)}</b>
        </S.CreditCardRow>

        <S.CreditCardRow>
          <span>Data do fechamento da próxima fatura:</span>
          <b>
            {getFormatDateReverse(client?.information?.dataFechamentoProxFatura)}
          </b>
        </S.CreditCardRow>

        <S.CreditCardRow>
          <span>Disponível Rotativo:</span>
          <b>R$ {Number(cardFinancial?.saldoDisponivelRotativo || 0).toFixed(2)}</b>
        </S.CreditCardRow>

        <S.CreditCardRow>
          <span>Disponível para parcelamento:</span>
          <b>R$ {Number(cardFinancial?.saldoDisponivelParcelado || 0).toFixed(2)}</b>
        </S.CreditCardRow>

        <S.CreditCardRow>
          <span>Devedor Rotativo:</span>
          <b>R$ {Number(cardFinancial?.devedorRotativo || 0).toFixed(2)}</b>
        </S.CreditCardRow>

        <S.CreditCardRow>
          <span>Devedor para parcelamento:</span>
          <b>R$ {Number(cardFinancial?.devedorParcelado || 0).toFixed(2)}</b>
        </S.CreditCardRow>
      </S.InformationCardContainer>
    </Modal>
  );
}

export default memo(InformationCardModal);